"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryLabel = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

exports.CategoryLabel = utils_2.forwardRef(function Grid(props, ref) {
  var children = props.children;
  var categoryLabelContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tmargin-top: 2em;\n\t\tmargin-bottom: 1em;\n\t\tmargin-left: 2em;\n\t"], ["\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t\tline-height: 18px;\n\t\tmargin-top: 2em;\n\t\tmargin-bottom: 1em;\n\t\tmargin-left: 2em;\n\t"])), foundation_1.colors.white);
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: categoryLabelContainer
  }, children);
});

if (utils_1.isDev) {
  exports.CategoryLabel.displayName = 'CategoryLabel';
}

var templateObject_1;